import {
    dataLayerAddPGPlusToCart,
    dataLayerAddVisaToCart,
} from '@/src/common/utilities/gtag'

interface ISendEvents {
    brandName: string
    denomination: number
    designName: string
    cardQuantity: number
    productMediumType: string
    isBrandedGiftPage?: boolean
    brandCategories?: any[]
    brandQueryId?: string | null
}

function sendDataLayerEvents({
    brandName,
    designName,
    denomination,
    cardQuantity,
    productMediumType,
    isBrandedGiftPage = false,
    brandQueryId = null,
    brandCategories = [],
}: ISendEvents) {
    if (isBrandedGiftPage) {
        return dataLayerAddPGPlusToCart(
            ['eec.add', 'add_to_cart'],
            denomination,
            designName,
            brandName,
            brandCategories,
            !!brandQueryId,
            cardQuantity
        )
    }

    return dataLayerAddVisaToCart(
        ['eec.add', 'add_to_cart'],
        productMediumType,
        denomination,
        cardQuantity,
        designName,
        false
    )
}

export default sendDataLayerEvents
